import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";

export const getAllActiveBlogs = createAsyncThunk(
  "Blog/FindAllActiveBlog",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Blog/FindAllActiveBlog`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blogs:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBlogByID = createAsyncThunk(
  "/Blog/FindByIDBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/FindByIDBlog`,
        { ID }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const getBlogByBlogURL = createAsyncThunk(
  "/Blog/BlogFindByURL",
  async (BlogURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/BlogFindByURL`,
        { BlogURL: BlogURL }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
